import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from 'node_modules/@angular/common';
import { Router, NavigationEnd, Event, NavigationError, Scroll } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { SharedService } from '@smarttask-app/src/app/services/AngularSpecific/shared.service';
import { SharedEventModel } from '@smarttask-common/src/lib/models/AngularSpecific/SharedEventModel';
import { Globals } from '@smarttask-common/src/lib/services/globals';
import { filter } from 'rxjs';
import { SharedEventNameEnum } from '@smarttask-common/src/lib/models/AngularSpecific/SharedEventNameEnum';
import { SessionCookieModel } from '@smarttask-common/src/lib/models/Internal/SessionCookieModel';
import { DateTime } from 'luxon';

declare var ga;

@Injectable({
    providedIn: 'root',
})
export class WebsiteLocationService {
    constructor(
        @Inject(PLATFORM_ID) private platformId: Object,
        private router: Router,
        private globals: Globals,
        private cookieService: CookieService,
        private sharedService: SharedService
    ) {

        if (isPlatformBrowser(this.platformId)) {
            this.monitorRouteChangeSuccess();
            this.monitorRouteScroll();
        }
        this.monitorRouteChangeErrors();
    }

    goToLocationAndForceReload = (url) => {
        //Inform InitializeService to refresh deferredMain so that route change would wait for reload
        setTimeout(() => {
            url = decodeURIComponent(url);
            window.location.href = url; //Go to url relative to domain (Will close angular app)
            //window.location.reload();
        }, 500);
    };

    private monitorRouteChangeSuccess() {
        this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
            this.globals.previous_url = event.url; // Modify as needed

            this.monitorTrafficSource();

            let sharedEvent = new SharedEventModel();
            sharedEvent.name = SharedEventNameEnum.route_change_success;
            this.sharedService.broadcast(sharedEvent);
        });
    }

    private monitorRouteScroll = () =>{
        this.router.events
            .pipe(filter((e): e is Scroll => e instanceof Scroll))
            .subscribe((e) => {
                // Back/forward: restore exact position
                if (e.position) {
                    //window.scrollTo(e.position[0], e.position[1]);
                    return;
                }

                // Anchor navigation (#id)
                if (e.anchor) {
                    document.getElementById(e.anchor)?.scrollIntoView();
                    return;
                }

                // Forward navigation: go to top
                document.body.scrollTop = document.documentElement.scrollTop = 0;
            });
    }

    monitorRouteChangeErrors = () => {
        this.router.events.subscribe((event: Event) => {
            if (event instanceof NavigationError) {
                console.log(event.error);
            }
        });
    };

    monitorTrafficSource = () => {
        let params = new URLSearchParams(window.location.search);
        let ref = params.get('ref') ?? params.get('utm_source');
        let gclid = params.get('gclid');
        const ltd_hint = params.get('ltd_hint');

        let cookie_value = this.cookieService.get(this.globals.cookie_names.session);
        if(cookie_value != undefined && cookie_value.length > 0){
            let session_info_in_cookie: SessionCookieModel = JSON.parse(cookie_value);
            if (ref && session_info_in_cookie.referrer == undefined) {
                session_info_in_cookie.referrer = ref;
                this.cookieService.set(this.globals.cookie_names.session, JSON.stringify(session_info_in_cookie), {
                    expires: DateTime.now().plus({ month: 1 }).toJSDate(),
                    path: '/',
                    domain: this.globals.cookie_domain,
                });
            }
        }
        else{
            let new_session: SessionCookieModel = {
                referrer: ref,
                landing_page: window.location.pathname,
                gclid: gclid,
                query: window.location.search,
            };
            this.cookieService.set(this.globals.cookie_names.session, JSON.stringify(new_session), {
                expires: DateTime.now().plus({ month: 1 }).toJSDate(),
                path: '/',
                domain: this.globals.cookie_domain,
            });
        }

        if(ltd_hint){
            this.cookieService.set(this.globals.cookie_names.ltd_hint, ltd_hint, {
                expires: DateTime.now().plus({ month: 1 }).toJSDate(),
                path: '/',
                domain: this.globals.cookie_domain,
            });
        }
    };
}
